import React from 'react'
import styles from './styles.module.css'

function Arrow(props) {
  const {
    color = '#018AD1',
    direction = 'left',
    width = 30,
    style = {}
  } = props

  function wrapStyle(direction) {
    if (direction === 'left' || direction === 'right') {
      return {
        width: `${width}px`,
        height: '10px'
      }
    } else {
      return {
        height: `${width}px`,
        width: '10px'
      }
    }
  }

  function top(params) {
    return (
      <div
        className={styles.wrap_top}
        style={{
          height: `${width}px`
        }}
      >
        <div
          className={styles.arrow_top}
          style={{
            borderColor: `transparent transparent ${color} transparent`
          }}
        />
        <div
          className={styles.line_top}
          style={{
            background: color,
            height: `${width}px`,
            position: 'absolute',
            top: '7px'
          }}
        />
      </div>
    )
  }

  function bottom(params) {
    return (
      <div
        className={styles.wrap_bottom}
        style={{
          height: `${width}px`
        }}
      >
        <div
          className={styles.line_bottom}
          style={{
            background: color,
            height: `${width}px`,
            zIndex: 1
          }}
        />
        <div
          className={styles.arrow_bottom}
          style={{
            borderColor: `${color} transparent transparent transparent`,
            position: 'absolute',
            bottom: '-7px'
          }}
        />
      </div>
    )
  }

  function left(params) {
    return (
      <div
        className={styles.wrap_left}
        style={{
          width: `${width + 8}px`
        }}
      >
        <div
          className={styles.arrow_left}
          style={{
            borderColor: `transparent ${color} transparent transparent`
          }}
        />
        <div
          className={styles.line_left}
          style={{
            background: color,
            width: `${width}px`,
            position: 'relative',
            left: '-8px',
            zIndex: 1
          }}
        />
      </div>
    )
  }

  function right(params) {
    return (
      <div
        className={styles.wrap_right}
        style={{
          width: `${width + 8}px`
        }}
      >
        <div
          className={styles.line_right}
          style={{
            background: color,
            width: `${width}px`,
            zIndex: 1
          }}
        />
        <div
          className={styles.arrow_right}
          style={{
            borderColor: `transparent transparent transparent ${color}`,
            position: 'relative',
            left: '-3px'
          }}
        />
      </div>
    )
  }

  function getArrow(direction) {
    const arrowSet = new Map()
    arrowSet
      .set('top', top())
      .set('bottom', bottom())
      .set('left', left())
      .set('right', right())
    return arrowSet.get(direction)
  }

  return (
    <div style={{ ...wrapStyle(direction), ...style }}>
      {getArrow(direction)}
    </div>
  )
}

export default Arrow
